import { configureStore } from '@reduxjs/toolkit';
import recipesReducer from './slices/recipesSlice';
import ordersReducer from './slices/ordersSlice';
import clientsReducer from './slices/clientsSlice';
import calendarReducer from './slices/calendarSlice';
import todoReducer from './slices/todoSlice';
import toastsReducer from './slices/toastsSlice';
import pricingReducer from './slices/pricingSlice';
import reviewQueueReducer from './slices/reviewQueueSlice';
import suppliersReducer from './slices/suppliersSlice';
import shipmentsReducer from './slices/shipmentsSlice';
import batchRecordsReducer from './slices/batchRecordsSlice';
import ingredientReceivingReducer from './slices/ingredientReceivingSlice';
import ingredientTraceCodesReducer from './slices/ingredientTraceCodesSlice';
import rawIngredientsReducer from './slices/rawIngredientsSlice';
import batchRecordIngredientsReducer from './slices/batchRecordIngredientsSlice';
import deliveryLogsReducer from './slices/deliveryLogsSlice';
import traceCodesReducer from './slices/traceCodesSlice';
import bakingProductionLogReducer from './slices/bakingProductionLogSlice';
import authReducer from './slices/authSlice';
import fillingBatchReducer from './slices/fillingBatchSlice';
import fillingBatchIngredientsReducer from './slices/fillingBatchIngredientSlice';
import componentBatchReducer from './slices/componentBatchSlice';
import componentBatchIngredientsReducer from './slices/componentBatchIngredientSlice';
import fillingBatchComponentBatchesReducer from './slices/fillingBatchComponentBatchSlice';
import batchRecordFillingBatchesReducer from './slices/batchRecordFillingBatchSlice';
import doughBatchReducer from './slices/doughBatchSlice';
import doughBatchIngredientsReducer from './slices/doughBatchIngredientSlice';
import batchRecordDoughBatchesReducer from './slices/batchRecordDoughBatchSlice';
import adminReviewReducer from './slices/adminReviewSlice';
import temperatureEquipmentReducer from './slices/temperatureEquipmentSlice';
import temperatureLogsReducer from './slices/temperatureLogSlice';
import sanitationReducer from './slices/sanitationSlice';
import { localStorageMiddleware } from './middleware/localStorageMiddleware';
import { geocodingMiddleware } from './middleware/geocodingMiddleware';

const store = configureStore({
  reducer: {
    recipes: recipesReducer,
    orders: ordersReducer,
    clients: clientsReducer,
    calendar: calendarReducer,
    todo: todoReducer,
    toasts: toastsReducer,
    pricing: pricingReducer,
    reviewQueue: reviewQueueReducer,
    suppliers: suppliersReducer,
    shipments: shipmentsReducer,
    batchRecords: batchRecordsReducer,
    ingredientReceiving: ingredientReceivingReducer,
    ingredientTraceCodes: ingredientTraceCodesReducer,
    rawIngredients: rawIngredientsReducer,
    batchRecordIngredients: batchRecordIngredientsReducer,
    deliveryLogs: deliveryLogsReducer,
    traceCodes: traceCodesReducer,
    bakingProductionLog: bakingProductionLogReducer,
    auth: authReducer,
    fillingBatches: fillingBatchReducer,
    fillingBatchIngredients: fillingBatchIngredientsReducer,
    fillingBatchComponentBatches: fillingBatchComponentBatchesReducer,
    batchRecordFillingBatches: batchRecordFillingBatchesReducer,
    componentBatches: componentBatchReducer,
    componentBatchIngredients: componentBatchIngredientsReducer,
    doughBatches: doughBatchReducer,
    doughBatchIngredients: doughBatchIngredientsReducer,
    batchRecordDoughBatches: batchRecordDoughBatchesReducer,
    adminReview: adminReviewReducer,
    temperatureEquipment: temperatureEquipmentReducer,
    temperatureLogs: temperatureLogsReducer,
    sanitation: sanitationReducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(localStorageMiddleware, geocodingMiddleware)
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export { store };
